<template>
    <div class="branch container" @click="clickshow($event)">
        <div class="search" v-if="!COMMON.isMobile">
            <i id="icon" class="icon show" @click="showOption = true;"></i>
            <input id="input" disabled placeholder="请选择分公司" :value="inputValue">
            <!-- <button class="search-button" :disabled="buttonclicked" @click="search()">查询</button> -->
            <div class="option show" v-show="showOption">
                <div class="hot-city show">
                    <h4 class="show">常用</h4>
                    <div class="hot-button">
                        <template v-if="hotCity.length > 0">
                            <button
                                v-for="(item,index) in hotCity"
                                :key="index"
                                @click="clickGet($event,item)"
                            >{{item.name}}</button>   
                        </template>
                    </div>
                </div>
                <template v-for="area in areas">
                    <div class="south-city show" v-if="area.id !== hideAreaId" :key="area.id">
                        <h4 class="show">{{area.name}}</h4>
                        <div class="south-button">
                            <button
                                v-for="(item, index) in area.customerServiceList"
                                :key="index"
                                @click="clickGet($event,item)"
                            >{{item.name}}</button>
                        </div>
                    </div>
                </template>
            </div>
            <div class="error" v-show="buttonclicked">
                <span>请选择分公司!</span>
            </div>
        </div>
        <div class="search" v-else>
            <select id="input" v-model="selectedCompany" @change="changeGet()">
                <option class="option" value disabled selected hidden>请选择分公司</option>
                <template v-for="area in areas">
                    <optgroup :label="area.name" :key="area.id">
                        <option
                            :value="item.id"
                            v-for="(item,index) in area.customerServiceList"
                            :key="index"
                        >{{item.name}}</option>
                    </optgroup>
                </template>
            </select>
        </div>
        <div class="brMap">
            <div v-show="mapError" class="branch-map-error"><img src="../../images/picture/wd_lost.png"/></div>
            <div class="branch-map" id="branch-map" ref="branch-map"></div>
            <div class="branch-info">
                <div class="company-name">
                    <p class="company">{{companyName}}</p>
                    <p
                        class="person"
                    >{{managerName}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{managerMobile}}</p>
                </div>
                <div class="points-list">
                    <div class="loading" v-show="loading">
                        <img src="../../images/icon/loading.gif">
                    </div>
                    <div
                        class="points"
                        :class="{on:item.isClicked}"
                        v-for="(item,index) in Warehouses"
                        :key="index"
                        @click="clickPoint($event,item,index)"
                    >
                        <i>{{index+1}}</i>
                        <div class="text">
                            <h4>{{item.name}}</h4>
                            <p>{{item.managerMobile}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import config from '@/config/env.js';
export default {
    metaInfo: {
        title: '网点查询-安得智联'
    },
    name: 'intor',
    data() {
        return {
            ak: 'uXRnW5KnsRHsIseRVNRrAvtnBWd2sVHR',
            isMobile: this.COMMON.isMobile,
            inputValue: undefined,
            companyName: '总部及研发中心',
            managerName: '客服热线',
            managerMobile: '400-000-0056',
            activeCompany: {},
            activeWarehouse: {},
            Warehouses: [],
            showOption: false,
            hotCityId: ['284', '4', '273', '17', '22', '16', '11'],
            tempAreas: [],
            areas: [],
            allCitys: [],
            hideAreaId: '259',
            mymap: {},
            BMap: null,
            selectedCompany: '',
            buttonclicked: false,
            mapError: false,
            loading: false
        };
    },
    components: {},
    methods: {
        mymapfun() {
            this.mymap = new this.BMap.Map('branch-map');
            this.mymap.centerAndZoom(
                new this.BMap.Point(113.211235, 22.907162),
                12
            );
            this.mymap.enableScrollWheelZoom(true);
        },
        search() {
            if (this.inputValue) {
                this.companyName = this.activeCompany.name;
                this.managerName = this.activeCompany.managerName;
                this.managerMobile = this.activeCompany.managerMobile;
                this.getWarehouse(this.activeCompany.id);
            } else {
                this.buttonclicked = true;
            }
        },
        clickshow(e) {
            //   e.target 是你当前点击的元素
            //   e.currentTarget 是你绑定事件的元素
            let className = e.target.className;
            if (className.indexOf('show') === -1) {
                this.showOption = false;
            } else {
                this.showOption = true;
            }
        },
        clickGet(e, item) {
            this.inputValue = item.name;
            this.activeCompany = item;
            this.buttonclicked = false;
            this.search();
        },
        changeGet() {
            let temp = this.allCitys.find(item => item.id === this.selectedCompany);
            if (!temp) {
                temp = this.hotCity[0];
            }
            this.inputValue = temp['name'];
            this.activeCompany = temp;
            this.companyName = temp.name;
            this.managerName = temp.managerName;
            this.managerMobile = temp.managerMobile;
            this.getWarehouse(temp.id);
        },
        clickPoint(e, item, index) {
            let that = this;
            this.Warehouses.map(item => {
                item.isClicked = false;
            });
            item.isClicked = true;
            let x = Number(item.longitude);
            let y = Number(item.latitude);
            if(x > 180 || x < -180 || y > 90 || y < -90) {
                this.mapError = true;
            }else{
                this.mapError = false;
            }
            this.mymap.centerAndZoom(
                new that.BMap.Point(item.longitude, item.latitude),
                16
            );
            this.showPoints(item, index + 1);
        },
        getCompany() {
            var self = this;
            self.$http
                .get(`${config.reqiestUrl}/api-portal/public/portal/customer/service/company/list`, {
                    params: {
                        id: 1
                    }
                })
                .then(function(response) {
                    if (
                        response.data &&
                        response.data.data
                    ) {
                        self.tempAreas = response.data.data;
                        self.tempAreas.forEach(item => self.allCitys.push(...item.customerServiceList));
                        self.areas = self.tempAreas;
                    }
                });
        },
        getWarehouse(id) {
            const that = this;
            that.loading = true;
            that.Warehouses = [];
            that.showPoints(that.Warehouses);
            that.$http
                .get(`${config.reqiestUrl}/api-portal/public/portal/customer/service/list`, {
                    params: {
                        id: id
                    }
                })
                .then(function(response) {
                    that.loading = false;
                    if (
                        response.data &&
                        response.data.data
                    ) {
                        const data = response.data.data;
                        data.isClicked = true;
                        that.Warehouses = data;
                        let points = new that.BMap.Point(
                            data.longitude,
                            data.latitude
                        );
                        that.mymap.setViewport(points); //根据点自动调整缩放比例
                        that.showPoints([that.Warehouses]);
                    }
                }, function() {
                    that.loading = false;
                });
        },
        showPoints(pointsOn, id) {
            const that = this;
            function ComplexCustomOverlay(point, text) {
                this._point = point;
                this._text = text;
            }
            //中心点下移，避开搜索框
            if (that.isMobile) {
                var curPix = this.mymap.pointToPixel(this.mymap.getCenter());
                var newPix = new that.BMap.Pixel(curPix.x, curPix.y - 40);
                var newCenter = this.mymap.pixelToPoint(newPix);
                this.mymap.setCenter(newCenter);
            }
            //添加点
            ComplexCustomOverlay.prototype = new that.BMap.Overlay();
            ComplexCustomOverlay.prototype.initialize = function(map) {
                this._map = map;
                var icon = require('../../images/icon/point_big.png');
                var div = (this._div = document.createElement('div'));
                div.style.cssText = 'position:absolute;color:#ffffff;text-align:center;' +
                                    'background-size:100%;font-size:11px;' +
                                    'z-index:' + that.BMap.Overlay.getZIndex(this._point.lat) +
                                    ';background:' + 'url(' + icon + ') no-repeat' +
                                    ';height:' + (that.isMobile ? '22px' : '30px') +
                                    ';width:' + (that.isMobile ? '18px' : '28px') +
                                    ';padding-top:' + (that.isMobile ? '1px' : '6px');
                div.appendChild(document.createTextNode(this._text));
                that.mymap.getPanes().markerPane.appendChild(div);
                return div;
            };
            ComplexCustomOverlay.prototype.draw = function() {
                var map = this._map;
                var pixel = map.pointToOverlayPixel(this._point);
                this._div.style.left = (pixel.x - 14) / 100 + 'rem';
                this._div.style.top = (pixel.y - 36) / 100 + 'rem';
            };
            this.mymap.clearOverlays();
            var myCompOverlay = [];
            if (id) {
                var pt = new this.BMap.Point(
                    pointsOn.longitude,
                    pointsOn.latitude
                );
                myCompOverlay[0] = new ComplexCustomOverlay(pt, id);
                that.mymap.addOverlay(myCompOverlay[0]);
            } else {
                pointsOn.map((item, index) => {
                    var pt = new this.BMap.Point(
                        item.longitude,
                        item.latitude
                    );
                    myCompOverlay[index] = new ComplexCustomOverlay(
                        pt,
                        index + 1
                    );
                    that.mymap.addOverlay(myCompOverlay[index]);
                });
            }
        }
    },
    mounted() {
        this.getCompany();
        this.BMap = window.BMap;
        this.mymapfun();
        this.getWarehouse(530);
    },
    computed: {
        hotCity() {
            let self = this;
            let temp = self.allCitys.filter(city => self.hotCityId.includes(city.id));
            let value = [];
            // 按hotCityId 的顺序排序
            self.hotCityId.forEach(hotId => {
                for (var i = temp.length - 1; i >= 0; i--) {
                    if(temp[i].id === hotId) {
                        value.push(temp[i]);
                        break;
                    }
                }
            });
            return value;
        }
    }
};
</script>
<style lang="less">
@import url(./branch.less);
</style>